import { useAppSelector } from '@/store/hook'
import { selectCountryNames } from '@/store/selectors/configSelector'

function useCountryName(countryName) {
  const countryNames = useAppSelector(selectCountryNames)

  const foundCountryNameConfig = countryNames.find(
    (country) => country?.value === countryName,
  )

  return foundCountryNameConfig ? foundCountryNameConfig.name : countryName
}

export default useCountryName
